import React, { FC, useEffect } from 'react';
import moment from 'moment/moment';
import { FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, UseFormOptions } from 'react-hook-form';

import { fc } from 'i18n';
import { close as closeSign } from 'assets/icons';
import Button from 'core/react/general/form/Button';
import { Preloader } from 'components/atoms/preloader';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { issueModalSelector } from 'core/redux/selectors/tep';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { InfoTable } from 'components/organisms/tables/info-table';
import { useReturnColumns } from 'hooks/tep/leases/useReturnColumns';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';

import styles from './styles.module.css';

const FORM_OPTIONS: UseFormOptions<{ returnedOn: Date }> = {
  mode: 'onChange',
};

export const ReturnModal: FC = () => {
  const dispatch = useDispatch();

  const { isLoading, error, selected, leases } = useSelector(issueModalSelector);

  const formMethods = useForm<{ returnedOn: Date }>(FORM_OPTIONS);

  const columns = useReturnColumns();

  const { setValue } = formMethods;

  const setFormValues = () => {
    setValue('returnedOn', selected?.lease?.returnedOn ? new Date(selected.lease.returnedOn) : new Date());
  };

  const close = () => dispatch(leasesActions.close());

  const returnLeases = () => {
    const returned: Record<string, string> = {};

    leases.forEach((entryPass) => {
      const date = entryPass.lease.returnedOn || new Date();

      returned[entryPass.id] = moment(date).format('YYYY-MM-DD');
    });

    dispatch(leasesActions.removeMultiple.request({ data: { leases: returned } }));
  };

  useEffect(() => {
    if (selected) {
      setFormValues();
    }
  }, [selected]);

  return (
    <ModalWrapper>
      <FormProvider {...formMethods}>
        <form className={styles.content}>
          <span className={styles.close} onClick={close}>
            <SvgWrapper width={26} height={26} details={closeSign} />
          </span>
          <div className={styles.title}>{fc('return overview')}</div>
          {/*@ts-ignore*/}
          <InfoTable isLoading={false} height={240} columns={columns} data={leases} />
          <div className={styles.totalCount}>{`Total No. Of Entries : ${leases.length}`}</div>
          <div className={styles.footer}>
            <div className={styles.error}>{error || ''}</div>
            <Button onClick={returnLeases} className={`${styles.submit} active`} type="button">
              <span>{fc('return')}</span>
            </Button>
          </div>
        </form>
        {isLoading && <Preloader />}
      </FormProvider>
    </ModalWrapper>
  );
};
